import { FilterState } from "@/types/application"

export const APPLICATION_FILTERS_STORAGE_KEY = "applications_filters_v2"

export const DEFAULT_APPLICATION_FILTERS: FilterState = {
  location: "all_locations",
  jobPostings: [],
  orientationBooked: null,
  trialBooked: null,
  vehicleBooked: null,
  personStatus: null,
  stage: null,
  stageReason: null,
}

export function readPersistedApplicationFilters(): FilterState {
  try {
    const raw = localStorage.getItem(APPLICATION_FILTERS_STORAGE_KEY)
    if (raw) {
      const parsed = JSON.parse(raw)
      const bool = (v: unknown) => (v === true || v === false ? v : null)
      const str = (v: unknown) => (typeof v === "string" ? v : null)
      return {
        location: str(parsed.location) ?? DEFAULT_APPLICATION_FILTERS.location,
        jobPostings: Array.isArray(parsed.jobPostings)
          ? parsed.jobPostings.filter((v: unknown) => typeof v === "string")
          : [],
        orientationBooked: bool(parsed.orientationBooked),
        trialBooked: bool(parsed.trialBooked),
        vehicleBooked: bool(parsed.vehicleBooked),
        personStatus: str(parsed.personStatus),
        stage: str(parsed.stage),
        stageReason: str(parsed.stageReason),
      }
    }
  } catch (_) {
    // ignore parse errors and fall back to defaults
  }
  return DEFAULT_APPLICATION_FILTERS
}
